import { supabase } from '../lib/supabase';

export const searchService = {
  // Save a search for later use
  async saveSearch(searchName, filters) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      
      if (!user) {
        throw new Error('User must be authenticated to save searches');
      }

      const { data, error } = await supabase?.from('saved_searches')?.insert([{
          user_id: user?.id,
          search_name: searchName,
          search_term: filters?.searchTerm || null,
          availability_type: filters?.availabilityType || null,
          category_id: filters?.categoryId || null,
          issuer: filters?.issuer || null
        }])?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error saving search:', error);
      throw error;
    }
  },

  // Get all saved searches for current user
  async getSavedSearches() {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      
      if (!user) {
        return [];
      }

      const { data, error } = await supabase?.from('saved_searches')?.select(`
          *,
          category:categories(id, name)
        `)?.eq('user_id', user?.id)?.order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching saved searches:', error);
      return [];
    }
  },

  // Delete a saved search
  async deleteSavedSearch(searchId) {
    try {
      const { error } = await supabase?.from('saved_searches')?.delete()?.eq('id', searchId);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error deleting saved search:', error);
      throw error;
    }
  },

  // Add search to history
  async addToHistory(filters, resultsCount) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      
      if (!user) {
        return null;
      }

      const { data, error } = await supabase?.from('search_history')?.insert([{
          user_id: user?.id,
          search_term: filters?.searchTerm || null,
          availability_type: filters?.availabilityType || null,
          category_id: filters?.categoryId || null,
          issuer: filters?.issuer || null,
          results_count: resultsCount
        }])?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error adding to search history:', error);
      return null;
    }
  },

  // Get search history for current user
  async getSearchHistory(limit = 10) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      
      if (!user) {
        return [];
      }

      const { data, error } = await supabase?.from('search_history')?.select(`
          *,
          category:categories(id, name)
        `)?.eq('user_id', user?.id)?.order('searched_at', { ascending: false })?.limit(limit);

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching search history:', error);
      return [];
    }
  },

  // Clear search history
  async clearHistory() {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      
      if (!user) {
        throw new Error('User must be authenticated');
      }

      const { error } = await supabase?.from('search_history')?.delete()?.eq('user_id', user?.id);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error clearing search history:', error);
      throw error;
    }
  }
};